/* eslint-disable no-unused-vars */
import baseClasses from '@/assets/less/base_classes.less';

import baseTheme from '@/assets/less/themes/base_theme.less';
import lightTheme from '@/assets/less/themes/light_theme.less';
import darkTheme from '@/assets/less/themes/dark_theme.less';
import duplex from '@/assets/less/themes/duplex_theme.less';
import oldTheme from '@/assets/less/themes/old_theme.less';
import {createApp} from 'vue/dist/vue.esm-bundler.js';
import App from './App.vue';
import router from './router';
import store from './store';
import {markRaw} from 'vue';

import mobileInjection from './ProjectInjections/MobileAppInjection';
import pageBehaviourInjection from './ProjectInjections/PageBehaviourInjection';
import baseJsCacheControl from './ProjectInjections/BaseJsCacheControl';
import winSizeControlInjection from './ProjectInjections/WinSizeControlInjection.js';

import ZForms from './ZForms';

// import components from '@/assets/less/components.less';

async function run() {
  await mobileInjection();
  pageBehaviourInjection();
  baseJsCacheControl();
  winSizeControlInjection(store);

  const mainVue = createApp(App).use(store).use(router);

  mainVue.markRaw = markRaw;

  window.ZFVue = mainVue;

  mainVue.mount('#app');
}

run();
